import { keyMap } from '@locales/lokalise/keyMap';
import { TRADING_ACCOUNT_FORM_TYPE } from 'global.enums';

export type AccountCreateToggleButtonType = {
  type: TRADING_ACCOUNT_FORM_TYPE;
  name: string;
};

export const selfTAccountButton = { type: TRADING_ACCOUNT_FORM_TYPE.SELF, name: keyMap.copyTradingSelfTrade };
export const masterAccountButton = { type: TRADING_ACCOUNT_FORM_TYPE.MASTER, name: keyMap.copyTradingMaster };
export const investorAccountButton = { type: TRADING_ACCOUNT_FORM_TYPE.INVESTOR, name: keyMap.copyTradingInvestor };
